import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Element from 'element-ui';
import {MessageBox} from 'element-ui';
import './styles/common.scss';
import './styles/barcode-styles/barcode.scss';
import { loadStyle } from './util/util';
import {getStore, setStore} from "@/util/store";
import {Loading} from 'element-ui';
import {Post, PostForm} from "@/util/http";
import 'element-ui/lib/theme-chalk/index.css'
import {
    iconfontUrl,
    iconfontVersion
} from '@/config/env';
// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
    loadStyle(iconfontUrl.replace('$key', ele));
});
import basicContainer from './components/basic-container/main'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'//
Vue.component('basicContainer', basicContainer);

Vue.prototype.$permissions = (type, id) => {
    return new Promise((resolve) => {
        PostForm('/caseRegister/editPermissions', {type, id}).then(res => {
            if (res.code == 200) {
                resolve(res)
            }
        })
    })
}
Vue.prototype.$check = (caseId) => {
    return new Promise((resolve) => {
        PostForm('/caseApprovalForm/check', {caseId}).then(res => {
            resolve(res.list)
        })
    })
}
Vue.prototype.$time = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let mt = dt.getMonth() + 1;
    let day = dt.getDate();
    let h = dt.getHours();//获取时
    let m = dt.getMinutes();//获取分
    let s = dt.getSeconds();//获取秒
    // 为类名为`.showTime`的元素添加时间
    return y + "-" + mt + "-" + day
}
Vue.prototype.$forAway = (arr) => {
    let forData = [];
    for (let i = 0; i < arr.length; i++) {
        if (!forData.some(e => e.id == arr[i].id)) forData.push(arr[i]);
    }
    return forData

}
router.beforeEach((to, from, next) => {
    if(to.path !='/wel/index'){
        if(sessionStorage.getItem('YINGFENG-MENU')){
            let menu = JSON.parse( sessionStorage.getItem('YINGFENG-MENU'))
            let passNot= menu.find(item => item.path ==to.path)
            if( passNot=== undefined ) return next('/')
        }else {
            next('/')
        }
    }
    let data = {
        fullPath: to.fullPath,
        name: to.name,
        path: to.path,
    }
    let state = false
    if (store.state.user.isCloseTip) {
        MessageBox.confirm("请注意确认暂存？", "提示", {
            confirmButtonText: "直接跳转",
            cancelButtonText: "返回暂存",
            type: "warning",
            closeOnClickModal: false,
        }).then(() => {
            store.state.user.isCloseTip = false
            store.commit("SET_MENU1", data.path);
            store.commit("SET_TAG", data);
            next()
            state = true
        })
    } else {
        store.commit("SET_MENU1", data.path);
        store.commit("SET_TAG", data);
        next()
        state = true
    }


    //beforeEach是router的钩子函数，在进入路由前执行
    if (to.meta.title && state) {

        //判断是否有标题
        document.title = to.meta.title
    } else {
        document.title = '盈峰'
    }

    if (to.name !== '首页' && to.path !== '/' && to.path !== '/wel/index' && state) {
        let list1 = getStore({name: 'tagList'})

        if (!list1) list1 = []
        for (let i in list1) {
            if (list1[i].fullPath == to.fullPath) {
                return
            }
            if (i == list1.length - 1) {
                list1.push(data)
            }
        }
        if (list1.length == 0) list1.push(data)
        store.commit("SET_TAGLIST", list1);

    }
})
window.eventBus = new Vue();
Vue.config.productionTip = false
Vue.use(Element)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
